<div class="modal-body">
    <ng-container *ngIf="services.isMobile()">
        <button *ngIf="closeReq" type="button" class="close" style=" position: fixed;
        position: fixed;
        right: 39px;
        height: 51px;
        z-index: 10;" data-dismiss="modal"  clickable (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </ng-container>
    <ng-container *ngIf="services.isDesktop()">
        <button *ngIf="closeReq" type="button" class="close" data-dismiss="modal"  clickable (click)="closeModal()" aria-label="Close">
            <svg viewBox="0 0 16 16"xmlns="http://www.w3.org/2000/svg">
                <g data-name="Group 14012" id="Group_14012" transform="translate(-5670.304 -485.804)">
                    <path d="M12,14a1.994,1.994,0,0,1-1.414-.586l-12-12a2,2,0,0,1,0-2.828,2,2,0,0,1,2.828,0l12,12A2,2,0,0,1,12,14Z" data-name="Linie 325" fill="#004A63" id="Linie_325" transform="translate(5672.304 487.804)"></path>
                    <path d="M0,14a1.994,1.994,0,0,1-1.414-.586,2,2,0,0,1,0-2.828l12-12a2,2,0,0,1,2.828,0,2,2,0,0,1,0,2.828l-12,12A1.994,1.994,0,0,1,0,14Z" data-name="Linie 326" fill="#004A63" id="Linie_326" transform="translate(5672.304 487.804)"></path>
                </g>
            </svg>
        </button>
    </ng-container>

    <div *ngIf="!name">
  <div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
  </div>

  <div class="modal-body">
    <p>{{ message }}</p>
  </div>

<div class="modal-footer">
  <button *ngIf="secondaryBtnLabel" class="btn btn-secondary"  (click)="secondaryBtnClick()">
    {{ secondaryBtnLabel }}
  </button>

  <button *ngIf="primaryBtnLabel" class="btn btn-primary" (click)="primaryBtnClick()">
    {{ primaryBtnLabel }}
  </button>
</div>

    <!-- <a [routerLink]="[{ outlets: { primary: ['home'] }},{ outlets: { popUp1: ['ECYMBNKREQPICUP'] }}]" > Open Popup </a> -->
    <div *ngIf="name == 'popUp1'">
        <router-outlet #popupRouterOutlet name="popUp1"></router-outlet>
    </div>
    <div *ngIf="name == 'popUp2'">
        <router-outlet #popupRouterOutlet name="popUp2"></router-outlet>
    </div>
    <div *ngIf="name == 'popUp3'">
        <router-outlet #popupRouterOutlet name="popUp3"></router-outlet>
    </div>
    <div *ngIf="name == 'popUp4'">
        <router-outlet #popupRouterOutlet name="popUp4"></router-outlet>
    </div>
    <div *ngIf="name == 'popUp5'">
        <router-outlet #popupRouterOutlet name="popUp5"></router-outlet>
    </div>
    <div *ngIf="name == 'popUp6'">
        <router-outlet #popupRouterOutlet name="popUp6"></router-outlet>
    </div>
    <div *ngIf="name == 'popUp7'">
        <router-outlet #popupRouterOutlet name="popUp7"></router-outlet>
    </div>
    <div *ngIf="name == 'popUp8'">
        <router-outlet #popupRouterOutlet name="popUp8"></router-outlet>
    </div>
    <div *ngIf="name == 'popUp9'">
        <router-outlet #popupRouterOutlet name="popUp9"></router-outlet>
    </div>
    <div *ngIf="name == 'popUp10'">
        <router-outlet #popupRouterOutlet name="popUp10"></router-outlet>
    </div>
</div>
<!-- <div *ngIf="false">
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark"  clickable (click)="closeModal()">Close</button>
  </div>
</div> -->